module.exports = __webpack_public_path__ + "img/u9023.de343c95.svg";